var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPfEIPostfinanceDiePost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 62,
    viewBox: "0 0 98 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .aPFDP{fill:#ffc830;}.bPFDP{fill:#ffc800;}.bPFDP,.cPFDP,.dPFDP,.ePFDP{fill-rule:evenodd;}.cPFDP{fill:#090b06;}.dPFDP{fill:#db0011;}.ePFDP{fill:#fff;}\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "aPFDP",
    width: 98,
    height: 62
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-209 -104.639)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bPFDP",
    d: "M209,117.638h98V152.78H209V117.638Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cPFDP",
    d: "M235.117,129.989H237.4c1.992,0,3.776.58,3.776,2.738,0,2.116-1.535,2.863-3.485,2.863H236.9v3.444h-1.784v-9.045Zm1.784,4.191h.664c.913,0,1.7-.292,1.7-1.328,0-1.079-.788-1.41-1.7-1.41H236.9v2.738Z",
    transform: "translate(-11.554 -5.464)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cPFDP",
    d: "M250.135,134.007a3.353,3.353,0,0,1,3.527,3.526,3.506,3.506,0,1,1-3.527-3.526Zm0,5.642c1.369,0,1.7-1.2,1.7-2.322a1.7,1.7,0,1,0-3.36,0c0,1.079.373,2.322,1.659,2.322Z",
    transform: "translate(-16.655 -7.241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cPFDP",
    d: "M265.26,135.542a4.586,4.586,0,0,0-1.535-.291c-.5,0-1.037.166-1.037.747,0,1.079,3.028.374,3.028,2.822,0,1.535-1.411,2.157-2.822,2.157a7.658,7.658,0,0,1-1.95-.291l.083-1.41a4.148,4.148,0,0,0,1.743.414c.415,0,1.12-.166,1.12-.788,0-1.328-3.028-.415-3.028-2.822,0-1.452,1.286-2.074,2.614-2.074a7.653,7.653,0,0,1,1.909.249l-.124,1.286Z",
    transform: "translate(-22.943 -7.241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cPFDP",
    d: "M271.6,134.035h-1.286V132.75H271.6v-1.328l1.743-.539v1.867h1.535v1.285H273.34v3.112c0,.581.166,1.12.83,1.12a1.473,1.473,0,0,0,.789-.207l.041,1.37a3.741,3.741,0,0,1-1.286.166,1.973,1.973,0,0,1-2.116-2.157v-3.4Z",
    transform: "translate(-27.123 -5.859)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cPFDP",
    d: "M280.579,129.989h5.062v1.453H282.4v2.2h3.07v1.453H282.4v3.941h-1.826v-9.046Z",
    transform: "translate(-31.665 -5.464)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cPFDP",
    d: "M291.666,129.1h1.743v1.659h-1.743V129.1Zm0,2.863h1.743v6.68h-1.743v-6.68Z",
    transform: "translate(-36.57 -5.069)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cPFDP",
    d: "M298.066,134.132h1.659v.913a2.516,2.516,0,0,1,2.2-1.038c1.577,0,2.282,1.078,2.282,2.614v4.191h-1.742v-3.569c0-.788,0-1.908-1.121-1.908-1.286,0-1.535,1.369-1.535,2.241v3.236h-1.741v-6.68Z",
    transform: "translate(-39.401 -7.241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cPFDP",
    d: "M311.982,134.5a5.568,5.568,0,0,1,2.324-.5c2.033,0,2.863.829,2.863,2.78v.872c0,.664.041,1.162.041,1.66,0,.539.042.995.084,1.493h-1.535a4.6,4.6,0,0,1-.083-1h-.042a2.3,2.3,0,0,1-2.034,1.162,2.141,2.141,0,0,1-2.364-1.991,1.987,1.987,0,0,1,1.161-1.909,5.21,5.21,0,0,1,2.241-.374h.954c0-1.078-.457-1.452-1.493-1.452a3.435,3.435,0,0,0-2.075.747l-.041-1.494Zm2.033,5.186a1.369,1.369,0,0,0,1.2-.58,2.207,2.207,0,0,0,.373-1.369h-.747c-.788,0-1.95.124-1.95,1.162,0,.539.5.788,1.12.788Z",
    transform: "translate(-45.227 -7.241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cPFDP",
    d: "M325,134.132h1.618v.913h.041a2.516,2.516,0,0,1,2.2-1.038c1.577,0,2.241,1.078,2.241,2.614v4.191h-1.743v-3.569c0-.788,0-1.908-1.12-1.908-1.245,0-1.535,1.369-1.535,2.241v3.236H325v-6.68Z",
    transform: "translate(-51.316 -7.241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cPFDP",
    d: "M343.164,135.584a3.055,3.055,0,0,0-1.2-.249c-1.078,0-1.743.872-1.743,2.116s.581,2.2,1.784,2.2a4.173,4.173,0,0,0,1.37-.331l.041,1.451a6.57,6.57,0,0,1-1.7.207c-2.2,0-3.32-1.493-3.32-3.526a3.149,3.149,0,0,1,3.236-3.444,5.174,5.174,0,0,1,1.7.207l-.167,1.37Z",
    transform: "translate(-57.241 -7.241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cPFDP",
    d: "M354.279,140.438a4.323,4.323,0,0,1-2.283.539,3.175,3.175,0,0,1-3.485-3.444c0-1.949,1-3.526,3.07-3.526,2.49,0,3.195,1.7,3.195,4.025h-4.605a1.728,1.728,0,0,0,1.909,1.659,4.285,4.285,0,0,0,2.2-.664v1.411Zm-1.162-3.609c-.041-.83-.456-1.577-1.411-1.577a1.517,1.517,0,0,0-1.535,1.577Z",
    transform: "translate(-61.718 -7.241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dPFDP",
    d: "M363.8,151.864h4.439l-.7,3.279h3.277l-.871,4.107h-3.278l-.623,3.07h-3.61l.207-1.079h2.532l.621-3.029h3.278l.415-2.033H366.2l.663-3.236h-2.2L364,156.179h-1.12l.913-4.315Z",
    transform: "translate(-67.873 -15.141)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ePFDP",
    d: "M335.523,168.475l.58-2.7h-30.91l-.581,2.7Z",
    transform: "translate(-42.297 -21.296)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cPFDP",
    d: "M331.349,157.965h-.913v.042l-1.12,5.187v.04h1.161v-.04s.332-1.577.374-1.7h.539a2.421,2.421,0,0,0,1.742-.622,1.816,1.816,0,0,0,.54-1.327,1.347,1.347,0,0,0-.374-1,2.789,2.789,0,0,0-1.949-.581Zm.041.913h.29a.75.75,0,0,1,.58.249.592.592,0,0,1,.209.539,1.028,1.028,0,0,1-1.12.913h-.291l.332-1.7Z",
    transform: "translate(-53.226 -17.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cPFDP",
    d: "M341.85,158.4a2.265,2.265,0,0,0-1.618-.58,2.638,2.638,0,0,0-2.2,1,3.656,3.656,0,0,0-.83,2.281,2.291,2.291,0,0,0,.622,1.619,2.029,2.029,0,0,0,1.493.58,3.133,3.133,0,0,0,2.241-.871,3.773,3.773,0,0,0,.872-2.364,2.373,2.373,0,0,0-.581-1.66Zm-2.407,3.983a1,1,0,0,1-.7-.291,1.325,1.325,0,0,1-.332-.955,2.912,2.912,0,0,1,.747-1.949,1.41,1.41,0,0,1,1.037-.456,1,1,0,0,1,.706.29,1.327,1.327,0,0,1,.332.954c0,.955-.623,2.407-1.784,2.407Z",
    transform: "translate(-56.715 -17.775)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cPFDP",
    d: "M309.218,157.965H307.85v.042l-1.08,5.187v.04h1.784a2.8,2.8,0,0,0,2.365-.953,3.414,3.414,0,0,0,.663-1.909c.084-1.494-.7-2.282-2.364-2.407Zm-.414.913h.083a1.712,1.712,0,0,1,1.245.374.922.922,0,0,1,.249.83c-.041,1.535-.7,2.24-2.074,2.24H308.1l.706-3.443Z",
    transform: "translate(-43.252 -17.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cPFDP",
    d: "M350.355,158.067a3.643,3.643,0,0,0-1.37-.249c-.913,0-1.991.414-1.991,1.618a1.492,1.492,0,0,0,1.037,1.369c.373.208.7.415.7.788a.819.819,0,0,1-.913.788,3.111,3.111,0,0,1-1.245-.374h-.041l-.042.041-.248.871v.042h0l.041.042a4.8,4.8,0,0,0,1.493.29,2.34,2.34,0,0,0,1.7-.58,1.662,1.662,0,0,0,.456-1.2,1.7,1.7,0,0,0-1.078-1.493c-.374-.209-.664-.415-.664-.747a.376.376,0,0,1,.125-.291,1.1,1.1,0,0,1,.664-.248,2.472,2.472,0,0,1,1.079.29h.041v-.042l.25-.87.041-.042Z",
    transform: "translate(-60.698 -17.775)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cPFDP",
    d: "M323.684,157.965h-3.07v.042l-1.12,5.187v.04h3.195v-.04l.166-.789.042-.083h-2.074l.29-1.327h1.826v-.042l.165-.829v-.083H321.32l.248-1.162H323.6v-.041l.166-.83v-.042h-.083Z",
    transform: "translate(-48.881 -17.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cPFDP",
    d: "M317.948,157.965h-1.2v.042l-1.079,5.187-.041.04h1.2v-.04l1.078-5.187.041-.042Z",
    transform: "translate(-47.169 -17.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cPFDP",
    d: "M358.185,157.965h-4.109v.042l-.166.83-.042.041h1.453l-.913,4.315v.04h1.162l.041-.04s.872-4.108.913-4.315h1.453l.042-.041.166-.83v-.042Z",
    transform: "translate(-64.088 -17.84)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfEIPostfinanceDiePost);
export default __webpack_public_path__ + "static/media/pf_e_i_postfinance_die_post.f712a8adabfb28932d8e7f5477495cb2.svg";
export { ForwardRef as ReactComponent };